import { render, staticRenderFns } from "./AnimatedSvgIllustration.vue?vue&type=template&id=53e95dc8&scoped=true"
import script from "./AnimatedSvgIllustration.vue?vue&type=script&lang=js"
export * from "./AnimatedSvgIllustration.vue?vue&type=script&lang=js"
import style0 from "./AnimatedSvgIllustration.vue?vue&type=style&index=0&id=53e95dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e95dc8",
  null
  
)

export default component.exports